import { Deserializable } from '../protocols/deserializable';

export class BankingInformationSubmission implements Deserializable {
  public new!: BankingInformationSubmissionData;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (!!this.new) {
      this.new = Deserialize.instanceOf(BankingInformationSubmissionData, this.new);
    }
  }
}

export class BankingInformationSubmissionData implements Deserializable {
  public nickname!: string;
  public institutionNumber!: string;
  public transitNumber!: string;
  public accountNumber!: string;

  public onDeserialize(): void {}
}
